import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BillingInformation, EndOrderDetails } from '@pedix-workspace/utils';

import { TranslocoDirective } from '@jsverse/transloco';
import {
  getArcaVatConditionName,
  isArcaVatConditionRequiringCuit,
  getArcaDocumentTypeName,
  isBillingInformationArca,
  ArcaDocumentType,
} from '@pedix-workspace/integrations-arca';

@Component({
  selector: 'pxw-order-details-billing',
  templateUrl: './order-details-billing.component.html',
  styleUrls: ['./order-details-billing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective],
})
export class OrderDetailsBillingComponent {
  readonly orderDetails = input.required<EndOrderDetails>();
  readonly billingInformation = input.required<BillingInformation | null | undefined>();

  readonly vatCondition = computed(() => {
    const billingInformation = this.billingInformation();

    if (isBillingInformationArca(billingInformation)) {
      return getArcaVatConditionName(billingInformation.vatCondition);
    }

    return billingInformation?.vatCondition || '--';
  });
  readonly billingName = computed(() => {
    const billingInformation = this.billingInformation();

    return billingInformation?.name || '--';
  });
  readonly billingDocument = computed(() => {
    const billingInformation = this.billingInformation();

    if (!billingInformation?.documentType || !billingInformation?.documentNumber) {
      return '--';
    }

    const documentTypeLabel = getArcaDocumentTypeName(
      billingInformation?.documentType as ArcaDocumentType,
    );

    return `${documentTypeLabel} ${billingInformation.documentNumber}`;
  });
  readonly documentType = computed(() => {
    const billingInformation = this.billingInformation();

    if (isBillingInformationArca(billingInformation)) {
      return getArcaDocumentTypeName(billingInformation.documentType);
    }

    return billingInformation?.documentType || '--';
  });
  readonly billingAddress = computed(() => {
    const billingInformation = this.billingInformation();

    return billingInformation?.address || '--';
  });
  readonly isVatConditionBusiness = computed(() => {
    return isArcaVatConditionRequiringCuit(this.billingInformation()?.vatCondition);
  });
  readonly billingEmail = computed(() => {
    const billingInformation = this.billingInformation();

    return billingInformation?.email || '--';
  });
}
